/* 게시판 류의 다이얼로그 */
import { BoardDialogStoreType, BoardDialogParamsType } from '@/types/boardDialog';
import { defineStore } from 'pinia';

export const useBoardDialogStore = defineStore({
  id: 'boardDialog',
  state: (): BoardDialogStoreType => ({
    boardDialogOption: {
      open: false,
      type: '',
      sequence: 0,
      callback: () => {},
    },
  }),

  getters: {},
  actions: {
    openBoardDialog(value: BoardDialogParamsType) {
      this.boardDialogOption = {
        open: true,
        type: value.type,
        sequence: value.sequence ? value.sequence : 0,
        callback: value.callback ? value.callback : () => {},
      };
    },
    closeBoardDialog(callback?: BoardDialogParamsType['callback']) {
      this.boardDialogOption = {
        open: false,
        type: '',
        callback: callback ? callback : () => {},
      };
    },
  },
});
